/**
 * HCP confirm modal manager
 */
class HCPConfirm {
  constructor() {
    // jQuery is required
    if (typeof jQuery === 'undefined') {
      throw new Error('Jquery is required.');
    }
  }

  init() {
    // set storage key
    this.key = 'servier_is_hcp';

    // set modal and show / hide it
    this.$modal = $('#authConfirmModal');

    if (this.$modal.length === 1) {
      // confirm is HCP
      this.$modal.on('click.hcp', '.btn-hcp-confirm-on', () => this.setIsHCP());

      // is not HCP
      this.$modal.on('click.hcp', '.btn-hcp-confirm-off', () => this.clear());

      this.toggleModal();
    }
  }

  /**
   * Hide / show modal
   */
  toggleModal() {
    if (this.$modal) {
      if (sessionStorage.getItem(this.key) === '1') {
        this.$modal.modal('hide');
      } else {
        this.$modal.modal('show');
      }
    }
  }

  /**
   * Set is HCP in storage
   */
  setIsHCP() {
    sessionStorage.setItem(this.key, '1');
  }

  /**
   * Remove item from storage
   */
  clear() {
    sessionStorage.removeItem(this.key);
  }
}

export default new HCPConfirm();



// WEBPACK FOOTER //
// ./scripts/classes/HCPConfirm.js